/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type VehicleUsagePermissionSettingDtoPermission = typeof VehicleUsagePermissionSettingDtoPermission[keyof typeof VehicleUsagePermissionSettingDtoPermission];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleUsagePermissionSettingDtoPermission = {
  PETS: 'PETS',
  ABROAD: 'ABROAD',
} as const;
